const richTextBlockPattern = /<(?:p|h[1-3]|ul|ol|li|br|hr)(?:\s|>|\/)/i;

const allowedTags = new Set([
    'B',
    'BR',
    'EM',
    'H1',
    'H2',
    'H3',
    'HR',
    'I',
    'LI',
    'OL',
    'P',
    'S',
    'SPAN',
    'STRONG',
    'U',
    'UL',
]);

const escapePlainText = (value: string): string =>
    value
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;')
        .replaceAll('\n', '<br>');

const sanitizeRichText = (value: string): string => {
    const document = new DOMParser().parseFromString(value, 'text/html');

    for (const element of [...document.body.querySelectorAll('*')]) {
        if (!allowedTags.has(element.tagName)) {
            element.replaceWith(document.createTextNode(element.textContent ?? ''));
            continue;
        }

        for (const attribute of [...element.attributes]) {
            element.removeAttribute(attribute.name);
        }
    }

    return document.body.innerHTML;
};

export const toProfileTaskRichTextHtml = (value: string | undefined): string => {
    if (value === undefined || value.length === 0) {
        return '';
    }

    return richTextBlockPattern.test(value) ? sanitizeRichText(value) : escapePlainText(value);
};

export const profileTaskRichTextToPlainText = (value: string | undefined): string | undefined => {
    if (value === undefined || value.length === 0) {
        return undefined;
    }

    const document = new DOMParser().parseFromString(toProfileTaskRichTextHtml(value), 'text/html');
    for (const breakElement of [...document.body.querySelectorAll('br')]) {
        breakElement.replaceWith(document.createTextNode('\n'));
    }

    return document.body.textContent ?? undefined;
};
